export const createAgendasTabDataFromDefault = (defaultData, extraContent) => {
  return {
    ...defaultData,
    content: {
      ...defaultData.content,
      ...extraContent,
    },
  };
};
